<template>
  <header class="sitenav">
    <div class="">
      <div class="row">
        <div class="col-12">
          <b-navbar toggleable="lg" class="d-flex align-items-start" type="light" v-bind:class="{sticky: isFixed == true}">
            
            
            <b-navbar-brand to="/" >
              <img
                class="img-fluid logo"
                src="../assets/imgs/henkel123/henkel-123-logo.png"
                alt="Lava y Gana en 123"
              />
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" class=" pr-lg-5" is-nav>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <template>
                 
                  <b-nav-item
                    class="fG text-center bold "
                    to="/"
                  >Inicio</b-nav-item>
                  <b-nav-item
                    class="fG text-center bold "
                    to="/ganadores"
                  >Ganadores</b-nav-item>
                  <b-nav-item
                    target="_blank"
                    class="fG text-center bold "
                    href="./terminos-y-condiciones.pdf"
                  >Términos y condiciones</b-nav-item>
                </template>


               
                

                <!-- <b-nav-item class="fM azulclaro text-center pt-2 bold cerrarsesion bold" href="/ganadores">
                  BENEFICIOS
                </b-nav-item>

                <b-nav-item class="fM azulclaro text-center pt-2 bold cerrarsesion bold" href="/#resena">
                  RESEÑA
                </b-nav-item>

                <b-nav-item class="fM azulclaro text-center pt-2 bold cerrarsesion bold" href="/#galeria">
                  GALERÍA
                </b-nav-item> -->

                

                 <!-- <b-nav-item class="fM text-center pt-2 bold cerrarsesion bold" @click="toggleOverlay()">
                  Contacto
                </b-nav-item> -->
                 

                <!-- <b-nav-item class="fC btnrojo text-center pt-2 bold cerrarsesion" @click="logout()">
                  Cerrar sesión
                  
                </b-nav-item> -->
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

export default {
  data() {
    return {
      uid: null,
      stickyTop: 10,
      isFixed: false
    };
  },
  computed: {},
 created: function (){
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function (){
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function () {
    //this.uid = fb.auth.currentUser.uid;
    
  },
  methods: {
    handleScroll (event) {
      // Any code to be executed when the window is scrolled
      // console.log('scroll')
      // console.log(window.scrollY)

      if(window.scrollY > 10){
        this.isFixed = true;
      }else{
        this.isFixed = false;
      }
    },
    logout() {
      this.$store.dispatch("logout");
    },
    toggleOverlay() {
      this.$store.state.overlay = !this.$store.state.overlay;

      console.log({click: this.$store.state.overlay})
    },
  },
};
</script>
